import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  Container,
} from "@mui/material";
import {
  CreateNewFolderOutlined,
  PersonOutline,
  WorkOutline,
  PhoneOutlined,
  ApartmentOutlined,
  Payment,
  CompareArrows,
} from "@mui/icons-material";

const createItems = [
  {
    label: "Create Deal",
    path: "/create/deal",
    icon: <CreateNewFolderOutlined sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Sponsor",
    path: "/create/sponsor",
    icon: <PersonOutline sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Source",
    path: "/create/source",
    icon: <WorkOutline sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Contact",
    path: "/create/contact",
    icon: <PhoneOutlined sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Asset",
    path: "/create/asset",
    icon: <ApartmentOutlined sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Tenant",
    path: "/create/tenant",
    icon: <Payment sx={{ fontSize: 60 }} />,
  },
  {
    label: "Create Loan Comp",
    path: "/create/loan-comp",
    icon: <CompareArrows sx={{ fontSize: 60 }} />,
  },
];

const CreatePage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: 3,
          mt: 2,
        }}
      >
        {createItems.map((item) => (
          <Card
            key={item.label}
            sx={{
              height: "100%",
              backgroundColor: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
              boxShadow:
                "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)",
              transition:
                "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow:
                  "0 10px 14px -3px rgba(0, 0, 0, 0.14), 0 6px 8px -4px rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            <CardActionArea
              component={Link}
              to={item.path}
              disableRipple={true}
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                p: 3,
                textDecoration: "none",
              }}
            >
              <CardContent sx={{ textAlign: "center", flexGrow: 1 }}>
                <Box sx={{ mb: 2, color: "#1B7A63" }}>{item.icon}</Box>
                <Typography
                  variant="h6"
                  component="h2"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  {item.label}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    </Container>
  );
};

export default CreatePage;
